import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const dishes = [{
  name: 'Pan-Seared Scallops',
  price: '$34',
  description: 'Hand-dived scallops, cauliflower purée, crispy pancetta, truffle oil.',
  image: 'https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  name: 'The Dock Tower',
  price: '$120',
  description: 'Lobster tail, king crab legs, oysters, prawns, mussels, house sauces.',
  image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Blackened Halibut',
  price: '$42',
  description: 'Cajun spiced halibut, mango salsa, coconut rice, lime beurre blanc.',
  image: 'https://images.unsplash.com/photo-1534939561126-855b8675edd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Squid Ink Linguine',
  price: '$32',
  description: 'Fresh pasta, clams, chili, garlic, white wine, parsley.',
  image: 'https://images.unsplash.com/photo-1563379926898-05f4575a45d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Grilled Octopus',
  price: '$28',
  description: 'Charred octopus, romesco sauce, fingerling potatoes, chorizo oil.',
  image: 'https://images.unsplash.com/photo-1599084993091-1cb5c0721cc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  name: 'Oysters Rockefeller',
  price: '$24',
  description: 'Half dozen local oysters, spinach, pernod, parmesan gratin.',
  image: 'https://images.unsplash.com/photo-1553163147-621957516919?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function MenuHighlights() {
  return <section id="menu" className="py-24 bg-navy-800" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-4" data-id="element-101">
            Culinary <span className="text-gold-500" data-id="element-102">Highlights</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-103">
            A selection of our chef's signature creations, inspired by the daily
            tides.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-104">
          {dishes.map((dish, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group bg-navy-900 border border-navy-700 hover:border-ocean-500 transition-colors duration-300" data-id="element-105">
              <div className="h-64 overflow-hidden relative" data-id="element-106">
                <img src={dish.image} alt={dish.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-107" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900 to-transparent opacity-60" data-id="element-108" />
                <div className="absolute bottom-4 right-4 bg-gold-500 text-navy-900 font-bold px-3 py-1 text-lg" data-id="element-109">
                  {dish.price}
                </div>
              </div>
              <div className="p-6" data-id="element-110">
                <h3 className="font-heading font-bold text-xl text-white mb-2 group-hover:text-ocean-400 transition-colors" data-id="element-111">
                  {dish.name}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-112">
                  {dish.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-113">
          <Link to="/menu" className="text-white border-b-2 border-gold-500 pb-1 hover:text-gold-500 transition-colors font-heading font-bold tracking-widest uppercase" data-id="element-114">
            View Full Menu
          </Link>
        </div>
      </div>
    </section>;
}